// extracted by mini-css-extract-plugin
module.exports = {"container":"BookStatusChangeButton__container","button":"BookStatusChangeButton__button"};